import { apiRequest } from '../request'

export const sendHeartbeat = (token: string) =>
  apiRequest('/heartbeat', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  })
